import {create} from 'zustand';
import {immer} from 'zustand/middleware/immer';
import {TestData, UploadedItem} from "@pages/entry/types";

type EntryFormValues = {
    company_name: string;
    your_name: string;
    email: string;
    tel: string;
    project_detail_section: string;
    project_detail_section_other_text: string;
    yoto_naiyo1: string;
    yoto_menseki1: string;
    shinsakikan_sinseitaio: string;
    mitsumori_iraijino_kibonoki: string;
    files: string;
    agree: string;
}

type EntryStore = {
    company_name: string;
    your_name: string;
    email: string;
    tel: string;
    project_detail_section: string[];
    project_detail_section_other_text: string;
    yoto_naiyo1: string;
    yoto_menseki1: string;
    shinsakikan_sinseitaio: string;
    mitsumori_iraijino_kibonoki: string;
    files: UploadedItem[];
    agree: boolean;

    reset: () => void;
    setValue: (name: string, value: string | boolean) => void;
    getValues: () => EntryFormValues;
    setTestData: (testData: TestData) => void;
    addFile: (file: UploadedItem) => void;
    removeFile: (id: string) => void;
}

export const createDefaultParams = () => {
    return {
        company_name: '',
        your_name: '',
        email: '',
        tel: '',
        project_detail_section: [],
        project_detail_section_other_text: '',
        yoto_naiyo1: '',
        yoto_menseki1: '',
        shinsakikan_sinseitaio: '',
        mitsumori_iraijino_kibonoki: '',
        files: [],
        agree: false,
    }
}

export const useEntryStore = create<EntryStore>()(
    immer(
        (set, get) => ({
                ...createDefaultParams(),

                reset: () => {
                    set((state) => {
                        const defaults = createDefaultParams();
                        state.company_name = defaults.company_name;
                        state.your_name = defaults.your_name;
                        state.email = defaults.email;
                        state.tel = defaults.tel;
                        state.project_detail_section = defaults.project_detail_section;
                        state.project_detail_section_other_text = defaults.project_detail_section_other_text;
                        state.yoto_naiyo1 = defaults.yoto_naiyo1;
                        state.yoto_menseki1 = defaults.yoto_menseki1;
                        state.shinsakikan_sinseitaio = defaults.shinsakikan_sinseitaio;
                        state.mitsumori_iraijino_kibonoki = defaults.mitsumori_iraijino_kibonoki;
                        state.files = defaults.files;
                        state.agree = defaults.agree;
                    })
                },

                setValue: (name: string, value: string | boolean) => {
                    set((state) => {

                        switch (name) {
                            case 'project_detail_section':
                                const idx = state.project_detail_section.indexOf(value as string);
                                if (idx >= 0)
                                    state.project_detail_section.splice(idx, 1);
                                else
                                    state.project_detail_section.push(
                                        value as string
                                    )
                                break;
                            case 'agree':
                                state.agree = value as boolean;
                                break;
                            default:
                                state[name] = value;
                                break;
                        }
                    })
                },
                getValues: () => {

                    return {
                        company_name: get().company_name,
                        your_name: get().your_name,
                        email: get().email,
                        tel: get().tel,
                        project_detail_section: get().project_detail_section.join(','),
                        project_detail_section_other_text: get().project_detail_section_other_text,
                        yoto_naiyo1: get().yoto_naiyo1,
                        yoto_menseki1: get().yoto_menseki1,
                        shinsakikan_sinseitaio: get().shinsakikan_sinseitaio,
                        mitsumori_iraijino_kibonoki: get().mitsumori_iraijino_kibonoki,
                        files: get().files.map(file => file.id).join(','),
                        agree: String(get().agree),
                    };
                },
                addFile(file: UploadedItem) {
                    set((state) => {
                        state.files.push(file);
                    })
                },
                removeFile(id: string) {
                    set((state) => {
                        const idx = state.files.findIndex(file => file.id === id);
                        if (idx >= 0) {
                            state.files.splice(idx, 1);
                        }
                    });
                },
                setTestData(testData: TestData) {
                    set((state) => {
                        state.company_name = testData.company_name;
                        state.your_name = testData.your_name;
                        state.email = testData.email;
                        state.tel = testData.tel;
                        state.project_detail_section = testData.project_detail_section;
                        state.project_detail_section_other_text = testData.project_detail_section_other_text;
                        state.yoto_naiyo1 = testData.yoto_naiyo1;
                        state.yoto_menseki1 = testData.yoto_menseki1;
                        state.shinsakikan_sinseitaio = testData.shinsakikan_sinseitaio;
                        state.mitsumori_iraijino_kibonoki = testData.mitsumori_iraijino_kibonoki;
                    })
                }

            }
        ))
)
